export default __webpack_public_path__ + "static/media/Datorsal9.7d2410fd.jpeg";